var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9668 12.0625C9.10742 12.0625 9.21875 12.0137 9.30078 11.916C9.38281 11.8223 9.42383 11.6953 9.42383 11.5352V9.92969H10.0156C10.6484 9.92969 11.1602 9.73047 11.5508 9.33203C11.9414 8.93359 12.1367 8.40625 12.1367 7.75V2.93945C12.1367 2.2793 11.9414 1.76367 11.5508 1.39258C11.1602 1.02148 10.6484 0.835938 10.0156 0.835938H2.5332C1.87695 0.835938 1.35938 1.02344 0.980469 1.39844C0.601562 1.76953 0.412109 2.2832 0.412109 2.93945V7.75C0.412109 8.40234 0.601562 8.92969 0.980469 9.33203C1.35938 9.73047 1.87695 9.92969 2.5332 9.92969H6.38281L8.38672 11.7402C8.50391 11.8496 8.60352 11.9297 8.68555 11.9805C8.77148 12.0352 8.86523 12.0625 8.9668 12.0625Z",
    fill: "#ADACC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.30d230a78476c7d3068e39829f8604b3.svg";
export { ForwardRef as ReactComponent };